import { useState } from 'react';
import { Button } from '../form/button';
import { Tooltip } from '../tooltip/tooltip';
import Icon from '../icons/icon';
import classNames from 'classnames';

export const ButtonGroup = <T,>({
  items,
  onClick,
  selected,
  className,
}: {
  items: { label: string; value: T; hover?: string }[];
  onClick: (value: T) => void;
  selected?: T;
  className?: string;
}) => {
  const [selectedButton, setSelectedButton] = useState<number>(
    selected
      ? items.findIndex((v) => {
          return v.value == selected;
        })
      : 0,
  );

  const handleOnClick = (buttonIdx: number, value: T) => {
    setSelectedButton(buttonIdx);
    onClick(value);
  };

  return (
    <>
      <div className={classNames('flex', className)}>
        {items.map(({ label, value, hover }, i) => (
          <Button
            key={i}
            className={selectedButton === i ? 'button-primary' : `button-tertiary`}
            onClick={() => handleOnClick(i, value)}
          >
            {label}
            {hover ? (
              <Tooltip tooltip={hover} type="black" invisible={false} maxWidth="200px">
                <Icon icon={'InfoCircle'}></Icon>
              </Tooltip>
            ) : (
              <></>
            )}
          </Button>
        ))}
      </div>
    </>
  );
};
